import { render, staticRenderFns } from "./InformationBox.vue?vue&type=template&id=5d8528a1&"
import script from "./InformationBox.vue?vue&type=script&lang=js&"
export * from "./InformationBox.vue?vue&type=script&lang=js&"
import style0 from "./InformationBox.vue?vue&type=style&index=0&id=5d8528a1&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports